import { ETableStructureType } from 'ui/EasTable/types';
import { TBoxStructure } from 'components/EMManagement/EMManagementId/EasParamsBox/types';
import { TPpwrEmSettingsView } from './types';

export const ppwrSettingsBoxStructure: TBoxStructure<TPpwrEmSettingsView> = {
	title: 'EPR/PPWR Settings',
	header: [],
	body: [
		{ name: 'Enabled', selector: 'enabled', type: ETableStructureType.BOOLEAN },
		{ name: 'Subscription', selector: 'subscriptionPlanName', type: ETableStructureType.STRING },
		{ name: 'Avg Sales Monthly', selector: 'avgSalesMonthly', type: ETableStructureType.NUMBER },
		{ name: 'Avg Parcel Items', selector: 'avgParcelItems', type: ETableStructureType.NUMBER },
		{ name: 'B2B Sales', selector: 'b2bSales', type: ETableStructureType.BOOLEAN },
		{
			name: 'Avg B2B Sales Monthly',
			selector: 'avgB2bSalesMonthly',
			type: ETableStructureType.NUMBER,
		},
		{ name: 'B2C Count in B2B', selector: 'b2cCountInB2b', type: ETableStructureType.NUMBER },
		{ name: 'Wholesale Method', selector: 'wholesaleMethod', type: ETableStructureType.STRING },
		{ name: 'Fulfilment Method', selector: 'fulfilmentMethod', type: ETableStructureType.STRING },
		{ name: 'Typical B2C Order', selector: 'typicalB2cOrder', type: ETableStructureType.STRING },
		{ name: 'Weight', selector: 'weight', type: ETableStructureType.NUMBER },
		{ name: 'Created At', selector: 'createdAt', type: ETableStructureType.DATE_TIME },
		{ name: 'Created By', selector: 'createdBy', type: ETableStructureType.USER },
		{ name: 'Updated At', selector: 'updatedAt', type: ETableStructureType.DATE_TIME },
		{ name: 'Updated By', selector: 'updatedBy', type: ETableStructureType.USER },
	],
};
